export default [
  {
    $ID: 'MainLayout',
    Name: 'Main page layout',
    Model:
      {
        '$ID': 'layout1',
        '$Type': 'MainLayout'
      }
  },
  {
    $ID: 'FullPageLayout',
    Name: 'Full page layout',
    Model:
      {
        '$ID': 'layout2',
        '$Type': 'FullPageLayout'
      }
  },
  {
    $ID: 'ExtendedLayout',
    Name: 'Extended page layout',
    Model:
      {
        '$ID': 'layout3',
        '$Type': 'ExtendedLayout'
      }
  },
  
]
  